PJQ.app.attachReadyEvent(function () {
	if (PJQ.app.module === PJQ.constants.modules.PROFILE_OLD) {
		PJQ.app.addOldRoutes([
			{
				route: '',
				name: 'default',
				callback: function () {
					if (PJQ.app.session.isLoggedIn()) {
						PJQ.app.router.navigate('profile', {
							trigger: true,
							replace: true
						});
					}
					else {
						if (PJQ.app.module === PJQ.constants.modules.APP) {
							PJQ.app.router.navigate('signin', {
								trigger: true,
								replace: true
							});
						}
						else {
							new PJQ.views.auth.AuthModal({
								contactId: PJQ.app.session.contact.id,
								defaultSignUpUsername: PJQ.app.session.contact.get('email')
							});
						}
					}
				}
			}
		]);
	}
});

PJQ.modules.profile = {
	routes: [
		{
			route: 'profile',
			name: 'myProfile',
			callback: function (key) {
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					PJQ.app.initNavigator({
						activeItem: "profile"
					});
				}
				else {
					PJQ.app.view.renderProfile();
				}
			}
		},
		{
			route: 'profiles/:key',
			name: 'profiles',
			callback: function (key) {
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					PJQ.app.initNavigator({
						activeItem: "profile",
						viewOptions: {
							key: key,
							shouldDoFirstRoute: false
						}
					});
				}
				else {
					PJQ.app.view.renderProfile(key);
				}
			}
		},
		{
			route: 'profiles/:key/:tab',
			name: 'profiles',
			callback: function (key, tab) {
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					PJQ.app.initNavigator({
						activeItem: "profile",
						viewOptions: {
							key: key,
							tab: tab,
							shouldDoFirstRoute: false
						}
					});
				}
				else {
					PJQ.app.view.renderProfile(key, tab);
				}
			}
		},
		{
			route: 'prequal',
			name: 'myPrequal',
			callback: function (accessKey) {
				if (PJQ.app.session.isLoggedIn()) {
					PJQ.app.initNavigator({
						activeItem: "prequal"
					});
				}
				else{
					new PJQ.views.auth.AuthModal({
						contactId: PJQ.app.session.contact.id,
						defaultSignUpUsername: PJQ.app.session.contact.get('email')
					});
				}
			}
		},
		{
			route: 'screenings/:accessKey',
			name: 'screenings',
			callback: function (accessKey) {
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					PJQ.app.initNavigator({
						activeItem: "screenings",
						viewOptions: {
							key: key,
							tab: tab,
							shouldDoFirstRoute: false
						}
					});
				}
				else {
					PJQ.modules.profile.initScreenings();
				}
			}
		},
		{
			route: 'screenings',
			name: 'screenings',
			callback: function () {
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					PJQ.app.initNavigator({
						activeItem: "screenings",
						viewOptions: {
							shouldDoFirstRoute: false
						}
					});
				}
				else {
					PJQ.modules.profile.initScreenings();
				}
			}
		}
	],
	oldRoutes: [
		{
			route: "?cid",
			callback: function () {
				if (PJQ.app.session.isLoggedIn()) {
					PJQ.app.router.navigate('profile', {
						trigger: true,
						replace: true
					});
				}
				else {
					new PJQ.views.auth.AuthModal({
						contactId: PJQ.app.session.contact.id,
						defaultSignUpUsername: PJQ.app.session.contact.get('email')
					});
				}
			}
		},
		{
			route: "?dir ?pid ?sid",
			callback: function () {
				if (PJQ.app.session.isLoggedIn()) {
					PJQ.app.router.navigate('screenings', {
						trigger: true,
						replace: true
					});
				}
				else {
					new PJQ.views.auth.AuthModal({
						contactId: PJQ.app.session.contact.id,
						defaultSignUpUsername: PJQ.app.session.contact.get('email')
					});
				}
			}
		}
	],
	initScreenings: function () {
		if (PJQ.app.session.isLoggedIn()) {
			let terms = new PJQ.collections.screenings.ScreeningTerms();
			terms.fetch({
				success: function () {
					if (_.find(terms.models, function (term) {
						return term.get('isActive') && !term.get('isAccepted')
					}) != null) {
						new PJQ.views.screenings.ScreeningTermsModal({
							collection: terms,
							onComplete: function () {
								PJQ.modules.profile.renderScreeningDashboard();
							}
						});
					}
					else {
						PJQ.modules.profile.renderScreeningDashboard();
					}
				}
			});
		}
		else {
			//if they dont have a userid > 0, show the login/registration form
			new PJQ.views.auth.AuthModal({
				contactId: PJQ.app.session.contact.id,
				defaultSignUpUsername: PJQ.app.session.contact.get('email')
			});
		}
	},
	renderScreeningDashboard: function () {
		PJQ.app.view.renderScreeningDashboard();
	}
};

PJQ.helpers.prequalHelpers = {
	addAll: function () {
		let result = 0;
		_.each(arguments, function (arg) {
			let flArg = parseFloat(arg);
			result += isNaN(flArg) ? 0 : flArg;
		});
		return result.toString();
	},
	multiplyAll: function () {
		if (_.size(arguments) <= 1) {
			return 0;
		}

		let result = null;
		_.each(arguments, function (arg) {
			let flArg = parseFloat(arg);
			if (isNaN(flArg)) {
				return;
			}
			result = result != null ? (flArg * result) : flArg
		});
		return result.toString();
	}
};

PJQ.app.addRoutes(PJQ.modules.profile.routes);

//We need to support old routes for all the old links floating around
PJQ.app.addOldRoutes(PJQ.modules.profile.oldRoutes);